<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-8 pt-4">
              <!--  -->
              <h4>Edit security role</h4>
              <div v-if="Loading === true">
                <div>
                  <div class="centered">
                    <a-spin />
                  </div>
                </div>
              </div>
              <div v-else>
                <p>Security role: {{ Role }}</p>
                <p>Security ID: {{ Id }}</p>
                <div style="display: flex;" class="p-2 rounded border">
                  <fieldset style="flex-grow: 1;" class="">
                    <legend>Authorized scripts</legend>
                    <div v-for="Group in AuthorizedScripts" :key="Group.group_ordinal">
                      <b>{{ Group.group_name }}</b>
                      <div v-for="Script in Group.scripts" :key="Script.script_id" class="d-flex">
                        <b-checkbox type="checkbox" :value="+Script.script_id" name="" id="" v-model="UpdatedAuthorizedScripts" />
                        {{ Script.friendly_name }}
                      </div>
                    </div>
                  </fieldset>
                  <fieldset style="flex-grow: 1;" class="">
                    <legend>Unauthorized scripts</legend>
                    <div v-for="Group in UnauthorizedScripts" :key="Group.group_ordinal" class="pb-2">
                      <b>{{ Group.group_name }}</b>

                      <div v-for="Script in Group.scripts" :key="Script.script_id" class="d-flex">
                        <b-checkbox type="checkbox" name="" id="" :value="+Script.script_id" v-model="UpdatedAuthorizedScripts" />
                        {{ Script.friendly_name }}
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div>
                  <!-- Security administrators rights -->
                  <fieldset class="border rounded p-2 mt-2">
                    <legend>
                      Security administrators rights
                    </legend>
                    <div class="form-group">
                      <label for="">Allow user to add new users?</label>
                      <div class="row">
                        <div class="col-md-2">
                          <label class="d-flex"><b-radio type="radio" name="newuser" v-model="NewUser" :value="false" /> No</label>
                        </div>
                        <div class="col-md-2">
                          <label class="d-flex"><b-radio type="radio" name="newuser" v-model="NewUser" :value="true" /> Yes</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="">Allow user to add new security roles?</label>

                      <div class="row">
                        <div class="col-md-2">
                          <label class="d-flex"><b-radio type="radio" name="newroles" v-model="NewRoles" :value="false" /> No</label>
                        </div>
                        <div class="col-md-2">
                          <label class="d-flex"><b-radio type="radio" name="newroles" v-model="NewRoles" :value="true" /> Yes</label>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <!-- Add or edit key value pairs -->
                  <fieldset class="border rounded p-2 mt-2" v-show="Keys.length > 0">
                    <legend>
                      Key/value pairs
                    </legend>

                    <div class="row" v-for="(Key, i) in Keys" :key="i">
                      <div class="col form-group">
                        <label>Key Name:</label>
                        <input type="text" size="10" name="keyname" v-model="Key.key" class="form-control" />
                      </div>
                      <div class="col form-group">
                        <label>Key Value:</label>
                        <input type="text" size="10" name="keyvalue" v-model="Key.value" class="form-control" />
                      </div>
                    </div>
                  </fieldset>

                  <div class="button-tray mt-2 mb-3">
                    <button class="btn btn-primary" type="button" @click="saveEditedSecurityRole">
                      Save
                    </button>
                    <router-link style="color: white;" class="ml-2 btn btn-danger" :to="{ name: 'DivvyAdminManageSecurityRoles' }">
                      Cancel
                    </router-link>
                  </div>
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import DivvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';

export default {
  name: 'EditSecurityRole',
  props: ['id'],
  data() {
    return {
      Role: '',
      Id: null,
      Keys: [],
      AuthorizedScripts: [],
      UnauthorizedScripts: [],
      UpdatedAuthorizedScripts: [],
      NewRoles: false,
      NewUser: false,
      Loading: false,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'manageRoles',
        activeMenu: this.activeMenu ? this.activeMenu : 'security',
      });
    },
    saveEditedSecurityRole() {
      const payload = {
        sec_id: this.Id,
        label: this.Role,
        sec_context: {
          version: '1.0',
          header: '',
          data: {
            struct: {
              var: [
                {
                  key: 'LABEL',
                  value: this.Role,
                },
                {
                  key: 'NEWCONTEXT',
                  value: this.NewRoles === false ? 'no' : 'yes',
                },
                {
                  key: 'NEWUSERS',
                  value: this.NewUser === false ? 'no' : 'yes',
                },
                {
                  key: 'SECID',
                  value: this.Id.toString(),
                },
                {
                  key: 'URLS',
                  value: this.UpdatedAuthorizedScripts.join(','),
                },
                ...this.Keys,
              ],
            },
          },
        },
        user_ids: {
          version: '1.0',
          header: '',
          data: {
            recordset: {
              row_count: '0',
              field_names: 'id,added',
              type: 'coldfusion.sql.QueryTable',
              fields: [
                {
                  key: 'id',
                  value: this.Id.toString(),
                },
                {
                  key: 'added',
                  value: 'no',
                },
              ],
            },
          },
        },
      };
      this.$store.dispatch('manageRoles/editSecurityRole', payload).then(() => {
        this.$router.push({
          name: 'DivvyAdminManageSecurityRoles',
        });
      });
    },
  },
  created() {
    this.setActiveMenuItem();
    try {
      this.Loading = true;
      this.$store
        .dispatch('manageRoles/fetchSecurityRolesById', {
          secid: this.id,
        })
        .then((data) => {
          this.Loading = false;
          this.Role = data.label;
          this.Id = data.sec_id;
          this.AuthorizedScripts = data.authorized_scripts;
          this.UnauthorizedScripts = data.unauthorized_scripts;
          // for newRoles
          const NewRoles = data.sec_context.data.struct.var.filter((keyval) => keyval.key === 'NEWCONTEXT');
          this.NewRoles = NewRoles[0].value === 'no' ? false : true;

          // for newUsers
          const NewUser = data.sec_context.data.struct.var.filter((keyval) => keyval.key === 'NEWUSERS');
          console.log(NewUser.value);
          this.NewUser = NewUser[0].value === 'no' ? false : true;

          // for updated authorized scripts
          const UpdatedAuthorizedScripts = data.sec_context.data.struct.var.filter((keyval) => keyval.key === 'URLS');
          this.UpdatedAuthorizedScripts = UpdatedAuthorizedScripts[0].value.split(',');
          this.UpdatedAuthorizedScripts = this.UpdatedAuthorizedScripts.map((num) => +num);
          // key/value pairs
          const KeyValuePairs = data.sec_context.data.struct.var.filter(
            (keyval) =>
              keyval.key !== 'URLS' && keyval.key !== 'LABEL' && keyval.key !== 'NEWCONTEXT' && keyval.key !== 'NEWUSERS' && keyval.key !== 'SECID'
          );
          this.Keys = KeyValuePairs;
        });
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
